import { createContext, useContext } from 'react'

import { type CasesTableType } from './types'

export interface CasesTableContextValue {
  tableType: CasesTableType
}

const casesTableContext = createContext<CasesTableContextValue | undefined>(undefined)

export const CasesTableProvider = casesTableContext.Provider

export const useCasesTableContext = () => {
  const context = useContext(casesTableContext)
  if (!context) {
    throw new Error(
      `Cases table context is not provided. It should be provided somewhere in one of the parent components of cases table.`
    )
  }
  return context
}
